/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getSchools, getStaffs } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import './companyReport.css';

export default function Staff() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const user = useSelector(({ auth }) => auth.user);
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const checkInReportRef = useRef(null);
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		role: '',
		school_id: '',
		fromDate: '',
		toDate: '',
	});

	const [schools, setSchool] = useState([]);
	const [searchQuery, setSearchQuery] = useState('');
	const [isLoadingExport, setIsLoadingExport] = useState(false);

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handlePrint = useReactToPrint({
		content: () => checkInReportRef.current,
	});

	// useEffect(() => {
	// 	const id = setTimeout(
	// 		() => {
	// 			setIsLoading(true);
	// 			setFirstLoad(false);
	// 			getStaffs(filters, 1, searchQuery)
	// 				.then(res => {
	// 					if (res.data.last_page > res.data.current_page) {
	// 						setHasMore(true);
	// 					} else {
	// 						setHasMore(false);
	// 					}
	// 					setPage(res.data.current_page + 1);
	// 					setRows(res.data.data);
	// 				})
	// 				.catch(err => {
	// 					dispatch(
	// 						Actions.showMessage({
	// 							message: 'Failed to fetch data, please refresh',
	// 							variant: 'error'
	// 						})
	// 					);
	// 				})
	// 				.finally(() => {
	// 					setIsLoading(false);
	// 				});
	// 		},
	// 		firstLoad ? 0 : 1000
	// 	);

	// 	return _ => {
	// 		clearTimeout(id);
	// 	};
	// 	// eslint-disable-next-line
	// }, []);

	const ApplyFilters = () => {
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		getStaffs(filters, 1, searchQuery)
			.then((res) => {
				setFirstLoad(false);
				setRows(res.data.data);
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				dispatch(
					Actions.showMessage({
						message: 'Report has been generated',
						variant: 'success',
					}),
				);
				// setPage(res.data.current_page + 1);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			})
			.finally(() => {
				setIsLoading(false);
			});
		setPage(1);
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getStaffs(filters, page, searchQuery)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch((err) => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		setFilters({ ...filters, [name]: value });
	};

	useEffect(() => {
		let isMounted = true;
		getSchools().then((res) => {
			if (!isMounted) return;
			setSchool(res?.data?.data);
		});
		return () => {
			isMounted = false;
		};
	}, []);

	const handleExport = () => {
		setIsLoadingExport(true);
		getStaffs(filters, page, searchQuery, 1)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `staff_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				setIsLoadingExport(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
				setIsLoadingExport(false);
			})
			.finally(() => {
				setIsLoadingExport(false);
			});
	};

	const staffType = [
		{
			value: 'lead',
			label: 'Lead',
		},
		{
			value: 'assistant',
			label: 'Assistant',
		},
		{
			value: 'admin',
			label: 'Admin',
		},
		{
			value: 'cook',
			label: 'Cook',
		},
	];
	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto allergy-cont">
				<div className="flex items-center flex-nowrap justify-between">
					<div className="reports-topDiv">
						<h1 className="">
							{' '}
							<span className="">
								<IconButton
									onClick={() => {
										navigate('/company-reports');
									}}
								>
									<img alt="filter" className="" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>{' '}
							<span className="text-pd-xl self-end font-bold mr-28">Staff</span>
						</h1>
						<p>Detail data of staff information </p>
					</div>
					<div className="flex justify-between">
						<div className="flex">
							<div className="self-end btn-aller">
								<span>
									{!isLoadingExport ? (
										<CustomButton
											height="40px"
											marginRight="17px"
											onClick={handleExport}
											variant="primary"
											width="100px"
										>
											<span className="mr-4">
												<FontAwesomeIcon icon={faDownload} />
											</span>
											Export
										</CustomButton>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
										<i aria-hidden="true" className="fa fa-print" /> Print
									</CustomButton>
									{/* <div className="help-btn cursor-pointer">
										<img src="assets/images/CENTER.png" />
										Help Center
									</div> */}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<TextField
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													id="search-icon"
													onClick={() => {
														document.getElementById('search-input').focus();
													}}
												>
													<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
												</IconButton>
											</InputAdornment>
										),
									}}
									className="mr-10"
									id="search-input"
									label="Search by Name"
									onChange={handleSearch}
									style={{ width: 150 }}
									value={searchQuery}
								/>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="staff_id">Staff Type</InputLabel>
									<Select
										endAdornment={
											filters.role ? (
												<IconButton className="mr-16" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																role: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="staff_id"
										label="Staff Type"
										labelId="staff_id"
										name="role"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.role}
									>
										{staffType?.length ? (
											staffType?.map((staff) => {
												return (
													<MenuItem key={staff.value} value={staff.value}>
														<span>{`${staff.label}`}</span>
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="schoolLabel">School</InputLabel>
									<Select
										endAdornment={
											filters?.school_id ? (
												<IconButton className="mr-16" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																school_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										label="School"
										labelId="schoolLabel"
										name="school_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.school_id}
									>
										<MenuItem value="All">All</MenuItem>
										{schools?.length ? (
											schools?.map((school) => {
												return (
													<MenuItem id={school?.id} key={school?.id} value={school?.id}>
														<div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{school?.name}</div>
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							{/* <div className="mx-8"> */}
							<div className="mx-10 student-date-field" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-from"
									label="Date From"
									maxDate={filters.toDate || new Date()}
									setValue={(date) => {
										setFilters({ ...filters, fromDate: date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.fromDate}
								/>
							</div>
							<div className="mr-20 ml-10 student-date-field" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-to"
									label="Date To"
									maxDate={new Date()}
									minDate={filters.fromDate}
									setValue={(date) => {
										setFilters({ ...filters, toDate: date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.toDate}
								/>
							</div>
							{/* </div> */}
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={
											!filters.fromDate && !filters.toDate && !filters.role && !filters.school_id ? !searchQuery : null
										}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="allergy-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={checkInReportRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography variant="subtitle1">
										<span style={{ display: 'block', marginBottom: '-0.7em', writingMode: '' }}>
											{user?.data?.school?.address}
										</span>{' '}
										{/* <span>Hom Lake, Orlando, FL 38637</span> */}
									</Typography>
									<Typography variant="subtitle1">{user?.data?.phone}</Typography>
									<Typography variant="subtitle1">{user?.data?.email}</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment(new Date()).format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Staff Report</h1>
							</div>

							<Table className="student-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Staff Name
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											School Name
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Hourly
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Role
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Date And Time
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												{/* <CircularProgress size={35} /> */}
											</TableCell>
										</TableRow>
									) : !rows?.length && !firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No record found
											</TableCell>
										</TableRow>
									) : (
										rows?.map((row) => (
											<TableRow key={row.id}>
												<TableCell className="bg-white ">
													<div className="flex flex-col">
														<div className="flex">
															<Avatar className="mr-6" src={row?.thumb} />
															<div className="flex  items-center justify-content: center">
																<div className="report-staff ">{row?.full_name}</div>
															</div>
														</div>
													</div>
												</TableCell>
												<TableCell className="bg-white ">
													<div className="flex flex-col">
														<div className="flex">
															<Avatar className="mr-6" src={row?.school?.logo} />
															<div className="flex  items-center justify-content: center">
																<div className="report-staff ">{row?.school?.name}</div>
															</div>
														</div>
													</div>
												</TableCell>
												<TableCell
													className="bg-white truncate"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													{row?.title == 'full-time' ? `Full Time` : `Part Time`}
												</TableCell>
												<TableCell
													className="bg-white truncate report-staff"
													style={{
														fontSize: '13px',
														maxWidth: '100px',
														fontWeight: 'bold',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													{row?.position_type}
												</TableCell>
												<TableCell component="th" scope="row">
													<div className="flex flex-col">
														<div className="report-staff">{moment(row?.created_at).format('MM/DD/YY')}</div>
														<div className="report-staff" style={{ color: 'gray' }}>
															{moment(row?.created_at).format('hh:mm A')}
														</div>
													</div>
												</TableCell>
											</TableRow>
										))
									)}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="student-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									Staff Name
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									School Name
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									Hourly
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									Role
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									Date And Time
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows?.length && !isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No record found
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell className="bg-white ">
											<div className="flex flex-col">
												<div className="flex">
													<Avatar className="mr-6" src={row?.thumb} />
													<div className="flex  items-center justify-content: center">
														<div className="report-staff ">{row?.full_name}</div>
													</div>
												</div>
											</div>
										</TableCell>
										<TableCell className="bg-white ">
											<div className="flex flex-col">
												<div className="flex">
													<Avatar className="mr-6" src={row?.school?.logo} />
													<div className="flex  items-center justify-content: center">
														<div className="report-staff ">{row?.school?.name}</div>
													</div>
												</div>
											</div>
										</TableCell>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											{row?.title == 'full-time' ? `Full Time` : `Part Time`}
										</TableCell>
										<TableCell
											className="bg-white truncate report-staff"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											{row?.position_type}
										</TableCell>
										<TableCell component="th" scope="row">
											<div className="flex flex-col">
												<div className="report-staff" style={{ fontSize: 12 }}>
													{moment(row?.created_at).format('MM/DD/YY')}
												</div>
												<div className="report-staff" style={{ color: 'gray', fontSize: 10 }}>
													{moment(row?.created_at).format('hh:mm A')}
												</div>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows?.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
}
